import { createAction } from '../../../../store.model';
import { CaResult } from '../../core';
import { ActionType } from '../ca-analysis-dialog.action';

export interface ReceiveResult {
    result: CaResult;
}

export const receiveResult = createAction<ActionType, ReceiveResult>(
    ActionType.COACHING__CA__RECEIVE_RESULT,
);
